import { lazy } from "react";

const chatRoutes = [
    {
        Path: "/jia/*",
        Component: lazy(() => import("../../container/Chat/routes")),
        meta: {
            name: "AI Chat"
        }
    }
]

export default chatRoutes;